const initState = {
    isFetching: false,
    displayLoader: false,
}

const bookingReducer = (state = initState, action) => {
    switch (action.type) {
        case 'LOADING_BOOKING':
            return {
                isFetching: true
            };

        case 'LOADED_BOOKING':
            return {
                data: [...action.data], 
                isFetching: false
            };    

        case 'CREATING_BOOKING':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'IMPORTING_BOOKING':
            return {
                ...action.data, 
                isFetching: true,
                displayLoader: true,
            };

        case 'IMPORTED_BOOKING':
            return {
                ...action.data, 
                isFetching: false,
                displayLoader: false,
            };

        case 'CREATE_BOOKING':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'CREATE_BOOKING_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'UPDATING_BOOKING':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'UPDATED_BOOKING':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'DUPLICATING_BOOKING':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'DUPLICATED_BOOKING':
            return {
                ...action.data, 
                isFetching: false
            };            

        case 'CONFIRMED_BOOKING':
            return {
                ...action.data, 
                isFetching: false, 
                bookingConfirmed: true
            };

        case 'UPDATE_BOOKING_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'DELETE_BOOKING':
            return action.data;

        case 'DELETE_BOOKING_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'GETTING_DRIVER_INFO':
            return {
                ...action.data, 
                isFetching: true
            };  
            
        case 'GET_DRIVER_INFO':
            return {
                driverInfo: action.data, 
                isFetching: false, 
                driverInfoReady: true
            };    

        case 'GETTING_DRIVER_DETAILS':
            return {
                ...action.data, 
                isFetching: true
            };  
            
        case 'GET_DRIVER_DETAILS':
            return {
                driverDetails: action.data, 
                isFetching: false, 
                driverDetailsReady: true
            };
    
        default:
            return state;
    }
}

export default bookingReducer;